/**
 * 잠깐 떴다 사라지는 알림 — 작업을 막지 않고 알려만 줄 때 (예: 연결 규칙 「잇고 알림」).
 * 막아야 하면 AppDialog 의 showAlert/showConfirm 을 쓴다.
 *
 *   showToast('…');               // 5초 뒤 사라진다. 누르면 바로 닫힌다
 *   <ToastHost />                 // 앱에 한 번 (App.tsx)
 */
import React, { useEffect, useState } from 'react';

interface ToastItem { id: number; message: React.ReactNode; kind: 'info' | 'warn' }

let seq = 0;
const listeners = new Set<(t: ToastItem) => void>();

export function showToast(message: React.ReactNode, kind: ToastItem['kind'] = 'warn'): void {
  const item = { id: ++seq, message, kind };
  listeners.forEach((f) => f(item));
}

export const ToastHost: React.FC = () => {
  const [items, setItems] = useState<ToastItem[]>([]);
  useEffect(() => {
    const add = (t: ToastItem) => {
      setItems((cur) => [...cur.slice(-3), t]);
      window.setTimeout(() => setItems((cur) => cur.filter((x) => x.id !== t.id)), 5000);
    };
    listeners.add(add);
    return () => { listeners.delete(add); };
  }, []);
  if (!items.length) return null;
  return (
    <div className="fixed bottom-10 left-1/2 -translate-x-1/2 z-[10002] flex flex-col items-center gap-2 pointer-events-none">
      {items.map((t) => (
        <button key={t.id} type="button" onClick={() => setItems((cur) => cur.filter((x) => x.id !== t.id))}
          className={`pointer-events-auto max-w-[640px] px-4 py-2 rounded-md shadow-lg text-sm text-left whitespace-pre-wrap border ${
            t.kind === 'warn' ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-white border-gray-300 text-gray-800'}`}>
          {t.message}
        </button>
      ))}
    </div>
  );
};
